import { render, staticRenderFns } from "./lottery_page_table.vue?vue&type=template&id=52e3f8ce&scoped=true"
import script from "./lottery_page_table.vue?vue&type=script&lang=ts"
export * from "./lottery_page_table.vue?vue&type=script&lang=ts"
import style0 from "./lottery_page_table.vue?vue&type=style&index=0&id=52e3f8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e3f8ce",
  null
  
)

export default component.exports